import { render } from "./Sav.vue?vue&type=template&id=2123a4c6&scoped=true&ts=true&lang=pug"
import script from "./Sav.vue?vue&type=script&lang=ts"
export * from "./Sav.vue?vue&type=script&lang=ts"

import "./Sav.vue?vue&type=style&index=0&id=2123a4c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2123a4c6"]])

export default __exports__